module.exports = __webpack_public_path__ + "static/media/7.ad7f0e8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/Artists/07/projects/01/7.jpg
// module id = 424
// module chunks = 0